import { render } from "./BaseWindow.vue?vue&type=template&id=7f870312"
import script from "./BaseWindow.vue?vue&type=script&lang=js"
export * from "./BaseWindow.vue?vue&type=script&lang=js"

import "./BaseWindow.vue?vue&type=style&index=0&id=7f870312&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__